export { Route as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-router-dom/es/Route.js
// module id = 1192
// module chunks = 0